<template>
  <div class="about">
    <h1>Forgot access code?</h1>
    <v-card outlined raised>
      <div v-if="!isAlertVisible">
        <UserApiSearch @selected-regid="setRegId"></UserApiSearch>
        <v-form v-model="isValid">
          <v-spacer></v-spacer>
          <v-col>
            <v-text-field
              v-model="email"
              outlined=""
              prepend-inner-icon="mdi-email"
              placeholder="E-mail"
              required
              :rules="emailRules"
            ></v-text-field>
          </v-col>
          <v-text-field
            v-model="regid"
            outlined
            required
            :rules="regidRules"
            readonly
            v-show="false"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!isValid"
              color="primary"
              @click="sendAcOnMail"
              :class="`d-flex justify-space-around mb-6`"
              >Email <v-icon right small>fa-envelope</v-icon></v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!isValid"
              color="primary"
              @click="sendAcOnSms"
              :class="`d-flex justify-space-around mb-6`"
              >SMS <v-icon right small>fa-sms</v-icon></v-btn
            >
            <v-spacer></v-spacer>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn icon @click="snackbar = true">
              <v-icon small>fa-info-circle</v-icon>
            </v-btn>
            <v-btn icon :to="cancellink.to">
              <v-icon small>fa-times-circle</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
          </v-row>
        </v-form>
      </div>
      <v-alert type="success" :value="isAlertVisible" dense>
        {{ statusResultMsg }}
        <v-btn
          :to="cancellink.to"
          color="primary"
          style="margin-left: 6px"
          v-if="!showEnterProfileKey"
          >OK</v-btn
        >
      </v-alert>
      <v-alert type="error" :value="isWarningAlertVisible" dense>{{
        statusResultMsg
      }}</v-alert>
    </v-card>
    <v-snackbar v-model="snackbar">
      {{ snackbartext }}

      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <ActivateAccountOnForgotAC
      v-if="showEnterProfileKey"
    ></ActivateAccountOnForgotAC>
  </div>
</template>

<script>
// @ is an alias to /src
import UserApiSearch from "@/components/airbox/UserApiSearch.vue";
import ActivateAccountOnForgotAC from "@/components/Admin/ActivateAccountOnForgotAC.vue";
import axios from "axios";

export default {
  name: "SendAC",
  // regid: Number,
  data() {
    return {
      regid: Number,
      email: String,
      eyevalue: true,
      isValid: true,
      emailRules: [
        (v) => !!v || "Email is required",
        // v => /.+@.+/.test(v) || 'E-mail must be valid'
        (v) =>
          /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            v
          ) || "E-mail must be valid",
      ],
      regidRules: [(v) => !!v || "User is required"],
      cancellink: { to: "/checkin" },
      isAlertVisible: false,
      isWarningAlertVisible: false,
      showAlertOKBtn: false,
      postTo: "",
      statusResult: Number,
      statusResultMsg: String,
      cancelBtnText: "",
      statuses: [],
      errors: [],
      snackbar: false,
      snackbartext:
        "To retrieve your Access Code: Search your name, enter your Email adress and send to either Email or by SMS.",
      showEnterProfileKey: false,
    };
  },
  created() {
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    this.regid = null;
    this.isValid = false;
    this.email = null;
  },
  methods: {
    setRegId(id) {
      this.regid = id;
      console.log(id);
    },

    sendAcOnMail() {
      var regId = this.regid;
      var email = this.email;
      var toSubmit = JSON.stringify({ email });
      const uri = this.baseUrl + "getacforemail/" + regId;
      //   console.log(uri)
      //   console.log(toSubmit)
      this.sendpost(uri, toSubmit, 0);
      // this.showEnterProfileKey = true;
      this.postTo = "email";
    },

    sendAcOnSms() {
      var regId = this.regid;
      var email = this.email;
      var respType = "AC";
      var msg = "";
      var toSubmit = JSON.stringify({ email, respType, msg });
      const uri = this.baseUrl + "gwasmssingle/" + regId;
      console.log(uri);
      console.log(toSubmit);
      this.sendpost(uri, toSubmit, 0);
      this.postTo = "sms";
      // this.showAlertOKBtn = true;
    },

    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
          if (this.statusResult == 1) {
            this.cancelBtnText = "Done";
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
        if (this.postTo === "email") {
          this.showEnterProfileKey = true;
        }
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
        this.showEnterProfileKey = false;
      }
    },
  },
  components: {
    UserApiSearch,
    ActivateAccountOnForgotAC,
  },
};
</script>